unit Web.Remittance.Utils;

interface

/// <summary>
///  Pure remittance list helpers (dates, sort field mapping) — testable without page forms.
/// </summary>
function GetValidRemittanceDate(const ADate: Double): TDateTime;

function GetRemittanceDateFromString(const ADateString: string): TDate;

function GetRemittanceOrderByFieldName(const AColumnTitle: string): string;

function BuildRemittanceOrderByParameter(const ASortField, ASortDirection: string): string;

function FormatRemittanceDateForDisplay(const ADate: TDateTime): string;

function ApplyListSortToggle(const ACurrentSortField, ACurrentSortDirection, AColumnTitle: string;
  out ANewSortField, ANewSortDirection: string): Boolean;

implementation

uses
  System.SysUtils;

function GetValidRemittanceDate(const ADate: Double): TDateTime;
begin
  Result := ADate;

  if (Result = 0) or (Result < 1) or (Result <> Result) then
    Result := 0;

end;

function GetRemittanceDateFromString(const ADateString: string): TDate;
var
  sDate: string;
  iYear: Integer;
  iMonth: Integer;
  iDay: Integer;

begin
  sDate := StringReplace(ADateString, '-', '', [rfReplaceAll]);
  sDate := StringReplace(sDate, '"', '', [rfReplaceAll]);

  iYear := StrToInt(Copy(sDate, 1, 4));
  iMonth := StrToInt(Copy(sDate, 5, 2));
  iDay := StrToInt(Copy(sDate, 7, 2));

  Result := EncodeDate(iYear, iMonth, iDay);

end;

function GetRemittanceOrderByFieldName(const AColumnTitle: string): string;
var
  sLowerTitle: string;

begin
  Result := '';
  sLowerTitle := LowerCase(Trim(AColumnTitle));

  if sLowerTitle = 'remittance date' then
    Result := 'RemittanceDate'
  else if sLowerTitle = 'payment state' then
    Result := 'PaymentState'
  else if sLowerTitle = 'payment ref' then
    Result := 'PaymentRef'
  else if sLowerTitle = 'invoice ref' then
    Result := 'InvoiceRef'
  else if sLowerTitle = 'id' then
    Result := 'Id';

end;

function BuildRemittanceOrderByParameter(const ASortField, ASortDirection: string): string;
begin
  Result := ASortField;

  if ASortDirection = 'DESC' then
    Result := Result + ' DESC';

end;

function FormatRemittanceDateForDisplay(const ADate: TDateTime): string;
begin
  if (ADate > 0) and (ADate >= 1) then
    Result := FormatDateTime('dd/mm/yyyy', ADate)
  else
    Result := '';

end;

function ApplyListSortToggle(const ACurrentSortField, ACurrentSortDirection, AColumnTitle: string;
  out ANewSortField, ANewSortDirection: string): Boolean;
var
  sResolvedField: string;

begin
  sResolvedField := GetRemittanceOrderByFieldName(AColumnTitle);
  Result := sResolvedField <> '';

  if not Result then
    Exit;

  if ACurrentSortField = sResolvedField then
  begin
    ANewSortField := sResolvedField;

    if ACurrentSortDirection = 'ASC' then
      ANewSortDirection := 'DESC'
    else
      ANewSortDirection := 'ASC';

  end
  else
  begin
    ANewSortField := sResolvedField;
    ANewSortDirection := 'ASC';

  end;

end;

end.
